import TiersIcon from '@material-ui/icons/BarChart';
import { APP_TYPES, roles } from '../../config/constants';
import TiersList from './components/TiersList';
import TierCreate from './components/TierCreate';
import TierEdit from './components/TierEdit';

const options = {
  appTypes: [APP_TYPES.IRELAND],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  subMenuName: 'manage',
  label: 'Tiers',
};

export default {
  list: TiersList,
  create: TierCreate,
  edit: TierEdit,
  icon: TiersIcon,
  name: 'admin/tiers',
  options,
};
